import{createSelector}from'reselect';/**
 * @param {Object} state The current application state.
 * @return {Object}
 */export var getPageState=function getPageState(state){return state.page;};/**
 * @param {Object} state The current application state.
 * @param {Object} props The current component props.
 * @return {Array|null}
 */export var getPageConfigById=createSelector(getPageState,function(state,props){return props.pageId;},function(pageState,pageId){if(!pageState||!pageState[pageId]){return null;}return pageState[pageId];});